import React from 'react';

export const DESKTOP_APP_PATH = '/settings?tab=desktop';

/**
 * "Get the desktop app" for CLIENT-account notices. Takes `onOpen` rather than calling
 * useNavigate: antd's hook modals render outside the router.
 */
const DesktopAppLink: React.FC<{ onOpen: () => void }> = ({ onOpen }) => (
    <a
        href={DESKTOP_APP_PATH}
        onClick={(e) => {
            e.preventDefault();
            onOpen();
        }}
        style={{ color: '#0ECB81', whiteSpace: 'nowrap' }}
    >
        Get the desktop app
    </a>
);

export default DesktopAppLink;
